module.exports = __webpack_public_path__ + "2eeef026f60ac03ba3bf35834e94928c.svg";